import useIsLimitedAccess from './useIsLimitedAccess';

const useShowLimitedAccessTopBanner = () => {
  const isLimitedAccess = useIsLimitedAccess();
  return isLimitedAccess;
};

export default useShowLimitedAccessTopBanner;
